import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${API}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errDetail(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Error inesperado";
}

export function imgUrl(u) {
  if (!u) return null;
  return u.startsWith("http") ? u : `${API}${u}`;
}

export const UNIT_LABEL = { doc: "doc", pzs: "pzs", set: "set" };
export const UNIT_NAME = { doc: "docena", pzs: "pieza", set: "set" };
export const unitOf = (p) => UNIT_LABEL[p.packing_unit] || "doc";
export const unitsTotal = (p, boxes) => boxes * (p.packing || 1);
export const lineTotal = (p, boxes) => unitsTotal(p, boxes) * (p.price_dozen || 0);
